import { render, staticRenderFns } from "./Fading-Alert.vue?vue&type=template&id=207d00d5&"
import script from "./Fading-Alert.vue?vue&type=script&lang=js&"
export * from "./Fading-Alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports